<div class="dialog-container">
  <div class="dialog-header flex_sb">
    <div class="dialog-header-title">
      {{ 'ENTER_PIN' | fallbackTranslate }}
    </div>
    <div class="dialog-header-cross flex-center" (click)="cancel_clicked()">
      <img [src]="images.CROSS" class="img-20" alt="close" />
    </div>
  </div>
  <div class="text">{{ 'PLZ_ENTER_EASY_EAT' | fallbackTranslate }}</div>

  <div class="dialog-form ta_center p-20">
    <!-- <ng-otp-input
        *ngIf="showOtpComponent"
        #ngOtpInput
        (onInputChange)="onOtpChange($event)"
        [config]="config"
    ></ng-otp-input> -->
    <div style="text-align: center">
      <custom-otp-input
        #ngOtpInput
        (onInputChange)="onOtpChange($event)"
        [config]="config"
        *ngIf="showOtpComponent"
      >
      </custom-otp-input>
    </div>

    <div class="fs-17 p-t-20 p-b-20" style="text-align: center">
      <!-- {{ currentText }} -->
    </div>

    <div class="calculator m-b-36">
      <app-virtual-keyboard
        (numberEntered)="getNumber($event)"
        (numBackClicked)="numBack($event)"
        [showDecimal]="false"
      ></app-virtual-keyboard>
    </div>
  </div>
</div>
